import React, { useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { LGTabPanel } from "../../molecules/LGTabPanel";
import CrudConfigs from "../../organisms/Configs/CrudConfigs";
import CrudQuoting from "../../organisms/Quoting/CrudQuoting.tsx";

const QuotingScreen = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <DashboardLayout>
      <Box
        sx={{
          backgroundColor: "white",
          borderBottom: 1,
          borderColor: "divider",
          position: "fixed",
          zIndex: 99,
          width: "100%",
        }}
      >
        <Tabs value={activeTab} onChange={handleChange}>
          <Tab label="Cotizaciones" />
          <Tab label="Configuración" />
          <Tab label="Procesos" />
        </Tabs>
      </Box>

      <LGTabPanel value={activeTab} index={0}>
        <Box sx={{ mt: 8 }}>
          <CrudQuoting />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={1}>
        <Box sx={{ mt: 8 }}>
          <CrudConfigs />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={2}>
        <Box sx={{ mt: 8 }}>
          <Typography>En construcción</Typography>
        </Box>
      </LGTabPanel>
    </DashboardLayout>
  );
};

export default QuotingScreen; 